module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundcolor"
  }), _c('div', {
    staticClass: "interview"
  }, [_c('q-modal', {
    ref: "minimezedModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        padding: '-1px',
        background: 'transparent',
        width: '90%'
      }
    }
  }, [(_vm.isVimeo(_vm.inter)) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.valvid)
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "logosection"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('span', {
    staticClass: "titretestintro"
  }, [_vm._v("THE "), _c('br')]), _c('span', {
    staticClass: "titretest"
  }, [_vm._v("INTERVIEWS")]), _c('hr', {
    staticClass: "lignemenu"
  })])]), _c('div', {
    staticClass: "contentsection"
  }, _vm._l((_vm.page.page_containers), function(p, index) {
    return ((index >= _vm.minListe() && index <= _vm.maxListe())) ? _c('div', {
      staticClass: "menucontent fl flex"
    }, [_c('div', {
      staticClass: "menustyle2"
    }, [_c('div', {
      staticClass: "white pointer",
      on: {
        "click": function($event) {
          _vm.test(p)
        }
      }
    }, [_vm._v(_vm._s(p.container.titre))])])]) : _vm._e()
  }))], 1), _c('div', {
    staticClass: "conteneurboutons"
  }, [(_vm.isMore) ? _c('q-btn', {
    staticClass: "boutonnext fr absolute",
    attrs: {
      "icon-right": "fa-caret-right"
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("Next")]) : _vm._e(), (_vm.isLess) ? _c('q-btn', {
    staticClass: "boutonlast fr absolute",
    attrs: {
      "icon": "fa-caret-left"
    },
    on: {
      "click": _vm.showLess
    }
  }, [_vm._v("Back")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0798cd6e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film/Interview.vue
// module id = 1274
// module chunks = 1